import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { TipoMetodoPagoInterface } from '@app/core/interfaces/tipo-metodo-pago-interface';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';

export const ID_TIPO_METODO_PAGO_DOMICILIACION = "1100001";
export const COMISION_BANCARIA_GIRO = 0.24;
export const COMISION_BANCARIA_NO_GIRO = 0;

@Injectable({
  providedIn: 'root'
})
export class TiposMetodoPagoService {

  urlTiposMetodoPago       = environment.api_base_url + '/tiposMetodoPago';

  public tiposMetodoPago$: BehaviorSubject<TipoMetodoPagoInterface[]> = new BehaviorSubject<TipoMetodoPagoInterface[]>(null);
  public tipoMetodoPago$: BehaviorSubject<TipoMetodoPagoInterface> = new BehaviorSubject<TipoMetodoPagoInterface>(null);
  public totalTiposMetodoPago$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  
  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set tipoMetodoPago(tipoMetodoPago: TipoMetodoPagoInterface) {
    this.tipoMetodoPago$.next(tipoMetodoPago);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<TipoMetodoPagoInterface[]> {
    if (paginatorType === TipoPaginadorEnum.offline) {
      return this.http.get(this.urlTiposMetodoPago, {}).pipe(
        tap( (data: RespApi )=> this.tiposMetodoPago$.next( data['data'] )),
        map((data: RespApi ) => data['data']));
    } else {
      return this.http.get(`${this.urlTiposMetodoPago}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
        tap( (data: RespApi )=> this.tiposMetodoPago$.next( data['data'] )),
        tap( (data: RespApi )=> {this.totalTiposMetodoPago$.next( data.total );}),
        map((data: RespApi) => this.mapearTipoMetodoPago( data['data'])) ); 
    }
  }

  mapearTipoMetodoPago( tipos: TipoMetodoPagoInterface[] ) {
    return tipos;
  }


  get(id): Observable<TipoMetodoPagoInterface>{
    return this.http.get(`${this.urlTiposMetodoPago}/${id}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }

  /************************************ 
    * Funciones apoyo                  *
    *************************************/
  resolve(): Observable<TipoMetodoPagoInterface[]> {
    return this.getAll().pipe(
      catchError(err => of(null))
    )
  }


}
